import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-nav-card',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './nav-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./nav-card.component.scss'],
})
export class NavCardComponent {
  icon = input.required<string>();
  title = input.required<string>();
  alert = input<string | null>(null);
  alertSeverity = input<'error' | 'warning'>('error');
  accent = input(false);
  cardClick = output<void>();
}
